import { Decoder } from "@ndn/tlv";
import { safeIter } from "@ndn/util";
/**
 * Decode TLVs from datagrams.
 * @param iterable - RX datagram stream, such as a UDP socket.
 * @returns RX packet stream.
 */
export async function* rxFromPacketIterable(iterable) {
    for await (const pkt of safeIter(iterable)) {
        const decoder = new Decoder(pkt);
        let tlv;
        try {
            tlv = decoder.read();
        }
        catch {
            continue;
        }
        yield tlv;
    }
}
